import React from "react";
import PropTypes from "prop-types";
import CircleButton from "../../commons/CircleButton";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { translate } from "../../../../infrastructure/translate/localization";
import { removeUploadingEmployees } from "../../../../usecases/employees/remove-uploading-employees";

import "./show-detail-employee.scss";
import "./show-delete-employees-modal.scss";

function ShowDeleteUploadingEmployeesModal({
  message,
  employees,
  state,
  page,
}) {
  return (
    <div className="modal-container">
      <CircleButton
        className="primary close-modal"
        icon="times"
        handlerClick={() => hideModal()}
      />
      <div className="modal-content">
        <div className="modal-left-line" />
        <span className="message">{message}</span>
        <div className="cob-btn-group center-group">
          <button
            type="button"
            className="cob-btn btn-primary-outline"
            onClick={() => removeUploadingEmployees(employees, page, state)}
          >
            {translate("actions.confirm")}
          </button>
          <button
            type="button"
            className="cob-btn btn-primary-outline"
            onClick={() => hideModal()}
          >
            {translate("actions.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

ShowDeleteUploadingEmployeesModal.defaultProps = { page: 1 };
ShowDeleteUploadingEmployeesModal.propTypes = {
  message: PropTypes.string.isRequired,
  employees: PropTypes.array.isRequired,
  state: PropTypes.string.isRequired,
  page: PropTypes.number,
};

export default ShowDeleteUploadingEmployeesModal;
